import { validators } from '@approvalmax/ui';
import { QualificationQuestionsAnswers } from 'modules/data/domain';

export const passwordIsValid = (password?: string) => {
    return !validators.password(password);
};

export const qualificationQuestionsAnswersIsValid = (
    qualificationQuestionsAnswers?: QualificationQuestionsAnswers | null
) => {
    if (!qualificationQuestionsAnswers) {
        return false;
    }

    for (let value of Object.values(qualificationQuestionsAnswers)) {
        if (!Array.isArray(value)) {
            return false;
        }

        if (value.length === 0) {
            return false;
        }
    }

    return true;
};
